import React, { createContext, useContext, useState, ReactNode } from "react";

// Define the shape of a network item
interface NetworkItem {
  key: string;
  value: string;
}

// Define context type
interface NetworkContextType {
  selectedNetworkfromFav: NetworkItem;
  setSelectedNetworkfromFav: (network: NetworkItem) => void;
}

// Create context
const FavNetworkContext = createContext<NetworkContextType | undefined>(undefined);

// Default empty network
const defaultNetwork: NetworkItem = { key: '', value: '' };

// Create provider
export const FavNetworkProvider = ({ children }: { children: ReactNode }) => {
  const [selectedNetworkfromFav, setSelectedNetworkfromFav] = useState<NetworkItem>(defaultNetwork);

  return (
    <FavNetworkContext.Provider value={{ selectedNetworkfromFav, setSelectedNetworkfromFav }}>
      {children}
    </FavNetworkContext.Provider>
  );
};

// Create custom hook
export const useFavNetwork = (): NetworkContextType => {
  const context = useContext(FavNetworkContext);
  if (!context) {
    throw new Error("useFavNetwork must be used within a FavNetworkProvider");
  }
  return context;
};